export default __webpack_public_path__ + "static/media/bg-cs-1.642127c9.png";